var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: _vm.dense ? '66.6px' : '82.6px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }